import React, { useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import { GraduationCap, CheckCircle, Sparkles, Layers, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function MethodologyContent() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-5" style={{ background: '#f8fafc', minHeight: '85vh' }}>
      <Helmet>
        <title>Contextual Systematic Theology (S.T.L) - Vidyajyoti College of Theology</title>
        <meta name="description" content="Licentiate in Sacred Theology (S.T.L) in Contextual Systematic Theology - Second Cycle Ecclesiastical Studies at Vidyajyoti." />
        <meta name="keywords" content="Contextual Theology, Systematic Theology India, STL Methodology, Vidyajyoti Licentiate" />
        <link rel="canonical" href="/academics/methodolgoy" />
      </Helmet>

      <div className="container">
        {/* Header Hero */}
        <div className="card border-0 rounded-4 shadow-sm p-4 p-md-5 mb-5" style={{ background: 'linear-gradient(135deg, #1a2b56 0%, #2a3f75 100%)', color: '#fff' }}>
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3" style={{ background: 'rgba(198, 146, 20, 0.2)', color: '#ffd56b', fontSize: '0.85rem', fontWeight: 600 }}>
                <Sparkles size={14} /> Second Cycle Specialization
              </div>
              <h1 className="display-6 fw-bold mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Licentiate in Sacred Theology (S.T.L.)
              </h1>
              <h5 className="text-light fw-normal mb-3" style={{ opacity: 0.9 }}>
                Contextual Systematic Theology &amp; Indian Christian Hermeneutics
              </h5>
              <p className="lead mb-0 text-light" style={{ fontSize: '1rem', lineHeight: '1.7', opacity: 0.85 }}>
                A specialized postgraduate cycle designed to impart advanced initiation into the scientific methods of theological scholarship, research dissertation writing, and contextual reflection across India and South Asia.
              </p>
            </div>
            <div className="col-lg-4 text-center mt-4 mt-lg-0">
              <div className="p-4 rounded-4" style={{ background: 'rgba(255, 255, 255, 0.08)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255, 255, 255, 0.15)' }}>
                <GraduationCap size={44} className="mb-2" style={{ color: '#ffd56b' }} />
                <h5 className="fw-bold mb-1 text-white">4 Semesters (2 Years)</h5>
                <p className="small mb-0 text-light opacity-75">Full-Time Residential Research</p>
                <hr style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
                <Link to="/academics/master" className="btn btn-sm w-100 rounded-pill fw-semibold text-white" style={{ background: '#79031d' }}>
                  View Syllabus Matrix
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Core Pillars */}
        <div className="row g-4 mb-5">
          <div className="col-md-6">
            <div className="card h-100 border-0 rounded-4 shadow-sm p-4 p-md-5 bg-white">
              <div className="d-flex align-items-center gap-3 mb-4">
                <div className="p-3 rounded-circle" style={{ background: 'rgba(26, 43, 86, 0.08)', color: '#1a2b56' }}>
                  <Layers size={26} />
                </div>
                <div>
                  <h4 className="fw-bold mb-0" style={{ color: '#1a2b56' }}>Methodology &amp; Requirements</h4>
                  <small className="text-muted">Research Degree Framework</small>
                </div>
              </div>
              <p className="text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                The second cycle which leads to the Licentiate Degree (S.T.L.) consists of an organic study of a particular area of theology and an advanced initiation into the methods of scholarly study and research. Besides the courses and seminars, this degree demands two major seminar research papers and a comprehensive Master’s Dissertation.
              </p>
              <p className="text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                The areas of specialization of particular concern to India and offered in this Faculty are Systematic and Indian Christian Theology. The Licentiate degree requires four semesters of study after completion of the B.Th. degree.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card h-100 border-0 rounded-4 shadow-sm p-4 p-md-5 bg-white">
              <div className="d-flex align-items-center gap-3 mb-4">
                <div className="p-3 rounded-circle" style={{ background: 'rgba(121, 3, 29, 0.08)', color: '#79031d' }}>
                  <ShieldCheck size={26} />
                </div>
                <div>
                  <h4 className="fw-bold mb-0" style={{ color: '#79031d' }}>Admission Prerequisites</h4>
                  <small className="text-muted">Academic Standards</small>
                </div>
              </div>

              <ul className="list-unstyled d-flex flex-column gap-3 mb-4">
                <li className="d-flex align-items-start gap-2">
                  <CheckCircle size={18} className="text-success flex-shrink-0 mt-1" />
                  <span className="text-muted small">B.Th. degree from Vidyajyoti or recognized faculty with an average of at least 55% (High Second Class).</span>
                </li>
                <li className="d-flex align-items-start gap-2">
                  <CheckCircle size={18} className="text-success flex-shrink-0 mt-1" />
                  <span className="text-muted small">Completion of the six years of ecclesiastical studies in Philosophy and Theology approved by the Admission Board.</span>
                </li>
                <li className="d-flex align-items-start gap-2">
                  <CheckCircle size={18} className="text-success flex-shrink-0 mt-1" />
                  <span className="text-muted small">Students are expected to complete the Licentiate requirements within two academic years.</span>
                </li>
              </ul>

              <div className="mt-auto p-3 rounded-3 bg-light border">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="small fw-semibold text-dark">Ready to apply?</span>
                  <Link to="/admission/details" className="btn btn-sm rounded-pill text-white" style={{ background: '#1a2b56' }}>
                    View Admission Details
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
